import React from 'react';
import Lottie from 'lottie-react';
import VideoWithFallback from '../VideoWithFallback';
import '../WhyUsSection.css';
import onlineLearningAnimation from '../../assets/animations/online-learning.json';
import businessmanRocketAnimation from '../../assets/animations/businessman-rocket.json';
import teacherMathAnimation from '../../assets/animations/teacher-math.json';
import processAnimation from '../../assets/animations/process.json';

const AuditedWhyUsSection: React.FC = () => {
  const benefits = [
    {
      animation: businessmanRocketAnimation,
      title: "Dbanie o motywacje ucznia",
      description: "Zamiast nudnych wykladow - interaktywne zajecia, ktore pokochaja nawet ci, ktorzy wczesniej nienawidzili matematyki!",
      details: "Nagradzamy kazdy sukces i pomagamy przezwyciezyc strach przed matematyka. Rezultat? 96% uczniow poprawia oceny juz w pierwszym miesiacu!"
    },
    {
      animation: teacherMathAnimation,
      title: "Doswiadczeni nauczyciele",
      description: "Nasi tutorzy to nie zwykli nauczyciele - to pasjonaci, ktorzy potrafia wytlumaczyc najtrudniejsze zagadnienia w prosty sposob!",
      details: "Pracowalismy juz z wieloma uczniami na roznym poziomie. Dzieki temu wiemy jak pomoc uczniom na kazdym poziomie nauki."
    },
    {
      animation: onlineLearningAnimation,
      title: "Nowoczesne metody nauczania",
      description: "Zapomnij o kredzie i tablicy! Uzywamy najnowszych technologii, ktore sprawiaja, ze matematyka staje sie fascynujaca!",
      details: "Tablice interaktywne, gry edukacyjne i wizualizacje 3D. Matematyka nigdy nie byla tak ciekawa!"
    },
    {
      animation: processAnimation,
      title: "Wierzymy w proces i konsekwencje",
      description: "Zadnych sztuczkow i cudow - tylko sprawdzona metodologia, ktora dziala od lat! Krok za krokiem do sukcesu.",
      details: "Regularne testy, ciagly monitoring postepow i dostosowanie tempa nauki. Kazdy uczen ma swoj unikalny plan rozwoju."
    }
  ];

  return (
    <section id="why-us" className="why-us-section">
      <div className="why-us-video-background">
        <VideoWithFallback
          videoSrc="/videos/OnlineLearning.mp4"
          fallbackImageSrc="/images/video-fallbacks/onlinelearning.jpg"
          className="why-us-video"
          alt="Online learning environment"
        />
      </div>

      <div className="why-us-container">
        <div className="section-header">
          <h2>Dlaczego warto wybrac Sigma Study?</h2>
        </div>

        <div className="benefits-layout">
          {benefits.map((benefit, index) => (
            <div key={index} className={`benefit-row ${index % 2 === 1 ? 'reverse' : ''}`}>
              <div className="benefit-content">
                <div className="benefit-animation">
                  <Lottie
                    animationData={benefit.animation}
                    loop={true}
                    autoplay={true}
                    style={{
                      width: '150px',
                      height: '150px'
                    }}
                  />
                </div>
                <div className="benefit-text">
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                  <p className="benefit-details">{benefit.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="why-us-cta">
          <button
            className="why-us-cta-button"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Umow lekcje probna
          </button>
        </div>
      </div>
    </section>
  );
};

export default AuditedWhyUsSection;
